import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import Auth from './modules/auth'
import Category from './modules/category'
import Courses from './modules/courses'

export default new Vuex.Store({
    modules: {
      Auth,
      Category,
      Courses
    },
    strict: false
})
